/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of reference the draft note belongs to. Designed for extensibility.
 * @export
 * @enum {string}
 */
export enum InternalApiDraftReferenceType {
    MONITORING_ALERT = 'MONITORING_ALERT',
    SCREENING_ALERT = 'SCREENING_ALERT',
    BRIDGE_ALERT = 'BRIDGE_ALERT',
    MANUAL_ALERT = 'MANUAL_ALERT',
    CASE = 'CASE'
}


export function instanceOfInternalApiDraftReferenceType(value: any): boolean {
    for (const key in InternalApiDraftReferenceType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiDraftReferenceType, key)) {
            if (InternalApiDraftReferenceType[key as keyof typeof InternalApiDraftReferenceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiDraftReferenceTypeFromJSON(json: any): InternalApiDraftReferenceType {
    return InternalApiDraftReferenceTypeFromJSONTyped(json, false);
}

export function InternalApiDraftReferenceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDraftReferenceType {
    return json as InternalApiDraftReferenceType;
}

export function InternalApiDraftReferenceTypeToJSON(value?: InternalApiDraftReferenceType | null): any {
    return value as any;
}

export function InternalApiDraftReferenceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiDraftReferenceType {
    return value as InternalApiDraftReferenceType;
}

